import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import i18n from 'i18n-react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const BackButton = (props, context) => {
  const { to, className, text, useHistory } = props;
  const { history } = context.router;

  const { pathname } = window.location;
  const paths = pathname
    .split('/')
    .filter((p) => p.length > 0 && Number.isNaN(+p));

  const params = new URLSearchParams(window.location.search);
  const id = params.get('id');
  const customRedir = params.get('customRedir');

  if (customRedir && customRedir === 'training') {
    return (
      <Link className={clsx('backLink', className)} to="/main/training">
        <FontAwesomeIcon icon={['fas', 'caret-left']} />
        <p>{text}</p>
      </Link>
    );
  }

  if (to && !useHistory) {
    return (
      <Link className={clsx('backLink', className)} to={page}>
        <FontAwesomeIcon icon={['fas', 'caret-left']} />
        <p>{text}</p>
      </Link>
    );
  }

  if (useHistory || paths.length > 1) {
    let targetRoute = paths.slice(0, paths.length - 1).join('/');
    if (id) {
      targetRoute = `${targetRoute}?id=${id}`;
    }
    return (
      <button
        className={clsx('backLink', className)}
        onClick={() => {
          if (useHistory) {
            history.goBack();
          } else {
            history.replace(`/${targetRoute}`);
          }
        }}
      >
        <FontAwesomeIcon icon={['fas', 'caret-left']} />
        <p>{text}</p>
      </button>
    );
  }

  return null;
};

export default BackButton;

BackButton.contextTypes = {
  router: PropTypes.object,
};

BackButton.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
  useHistory: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

BackButton.defaultProps = {
  className: null,
  to: null,
  useHistory: true,
  text: i18n.translate('general.back'),
};
